<!-- 🍎 APPLE-STYLE CONFIRMATION PAGE -->
<div class="apple-confirmation" *ngIf="this.parent.loading != true">

  <!-- Hero Section with animated checkmark -->
  <div class="hero-section">
    <div class="checkmark-circle">
      <svg class="checkmark" viewBox="0 0 52 52">
        <circle class="checkmark-circle-bg" cx="26" cy="26" r="25" fill="none"/>
        <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
      </svg>
    </div>

    <h1 class="hero-title" *ngIf="this.OfferRequest?.OfferRequestStatus?.ID < 10">
      {{ 'ThankYouForYouOrderRequest' | translate }}
    </h1>
    <h1 class="hero-title" *ngIf="this.OfferRequest?.OfferRequestStatus?.ID == 10">
      {{ 'ThankYouForYouPurchaseOrderRequest' | translate }}
    </h1>

    <p class="hero-subtitle">{{ ConfirmationMessage }}</p>

    <div class="hero-badges">
      <div class="badge badge-primary">
        <span class="badge-label">{{ 'RequestNumber' | translate }}</span>
        <span class="badge-value">#{{ OfferRequest?.ReferenceNumber }}</span>
      </div>
      <div class="badge badge-secondary" *ngIf="this.OfferRequest?.DebatorPO?.length > 0">
        <span class="badge-label">{{ 'DebatorPO' | translate }}</span>
        <span class="badge-value">#{{ OfferRequest?.DebatorPO }}</span>
      </div>
    </div>
  </div>

  <!-- Total Amount Card -->
  <div class="total-card" *ngIf="this.OfferRequest?.Cart">
    <div class="total-row">
      <span class="total-label">{{ 'Total' | translate }}</span>
      <span class="total-amount">
        <span class="amount-value">{{ this.OfferRequest.Cart?.Total?.UITotalQtyPriceNOVAT?.Integer }}<span class="amount-decimals">{{ this.OfferRequest.Cart?.Total?.UITotalQtyPriceNOVAT?.Decimals }}</span></span>
        <span class="amount-currency">{{ this.OfferRequest.Cart?.Currency?.Name }}</span>
      </span>
    </div>
  </div>

  <!-- Items Section -->
  <div class="section-card">
    <h2 class="section-title">{{ 'Items' | translate }}</h2>

    <div class="items-table">
      <!-- Header -->
      <div class="table-header">
        <div class="th th-index">#</div>
        <div class="th th-brand">{{ 'Brand' | translate }}</div>
        <div class="th th-product">{{ 'ProductNamePartNumber' | translate }}</div>
        <div class="th th-qty">{{ 'Quantity' | translate }}</div>
        <div class="th th-price">{{ 'Price' | translate }}</div>
        <div class="th th-total">{{ 'Total' | translate }}</div>
        <div class="th th-eta">{{ 'ETA' | translate }}</div>
      </div>

      <!-- Rows -->
      <div class="table-row"
           *ngFor="let item of this.OfferRequest?.Cart?.Items; let i = index"
           [ngClass]="{'row-selected': item?.IsSelected === true, 'row-awaiting': item?.CartItemStatus?.ID == -1, 'row-notfound': item?.CartItemStatus?.ID == -2 && item?.WasSearchedFor == true, 'row-valid': item?.CartItemStatus?.ID == 1, 'row-invalid': item?.CartItemStatus?.ID == 0}">

        <div class="td td-index">{{ i + 1 }}</div>

        <div class="td td-brand">
          <span *ngIf="item?.CartItemStatus?.ID >= 0">{{ item?.Product?.Brand?.Name }}</span>
          <span *ngIf="item?.CartItemStatus?.ID == -1">{{ 'ItemNeedsSelection' | translate }}</span>
          <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand == null">
            {{ 'SelectBrand' | translate }}
          </span>
          <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand != null">
            {{ item?.UserSelectedBrand?.Name }}
          </span>
        </div>

        <div class="td td-product">
          <span *ngIf="item.LoadingCell != true">{{ item?.UIProductValue }}</span>
          <mat-spinner diameter="18" *ngIf="item.LoadingCell == true"></mat-spinner>
          <i class="material-icons status-icon" *ngIf="item?.CartItemStatus?.ID == 1">check_circle</i>
        </div>

        <div class="td td-qty">
          <span class="moq-indicator" *ngIf="item?.SelectedOffer?.ChangedQunatityFromMOQ == true"
                matTooltip="{{'MOQDesc' | translate}} {{item.SelectedOffer?.MOQ}}"
                matTooltipClass="neutral-tool-tip"></span>
          <span *ngIf="item?.Quantity > 0">{{ item?.Quantity }}</span>
        </div>

        <div class="td td-price">
          <span *ngIf="item?.Price">{{ item?.Price?.UIUnitPrice }} {{ this.OfferRequest.Cart?.Currency?.Name }}</span>
        </div>

        <div class="td td-total">
          <span *ngIf="item?.Price">{{ item?.Price?.UIQtyPrice }} {{ this.OfferRequest.Cart?.Currency?.Name }}</span>
        </div>

        <div class="td td-eta">
          <span class="eta-indicator"
                [ngClass]="{'eta-urgent': item?.RequestDeliveryStatus?.ID == -1, 'eta-ready': item?.RequestDeliveryStatus?.ID == 0, 'eta-normal': item?.RequestDeliveryStatus?.ID == 1}"
                *ngIf="item?.RequestDeliveryStatus"
                matTooltip="{{item?.RequestDeliveryStatus?.Name}}"
                matTooltipClass="neutral-tool-tip"></span>
          <span *ngIf="item?.SelectedOffer?.LeadTime?.Units > 0">
            {{ item?.SelectedOffer?.LeadTime?.Units }} {{ item?.SelectedOffer?.LeadTime?.Type?.Name }}
          </span>
          <span *ngIf="!(item?.SelectedOffer?.LeadTime?.Units > 0)" class="eta-empty">—</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Order Details -->
  <div class="section-card">
    <h2 class="section-title">{{ 'OrderDetails' | translate }}</h2>

    <div class="info-grid">
      <div class="info-item" *ngIf="this.OfferRequest?.ConsolidationType">
        <div class="info-label">{{ 'OrderConsolidationType' | translate }}</div>
        <div class="info-value">{{ this.OfferRequest.ConsolidationType.Name }}</div>
      </div>

      <div class="info-item" *ngIf="this.OfferRequest?.DeliveryPreference">
        <div class="info-label">{{ 'DeliveryPreference' | translate }}</div>
        <div class="info-value">{{ this.OfferRequest.DeliveryPreference.Name }}</div>
      </div>

      <div class="info-item info-item-full" *ngIf="this.OfferRequest?.ShippingAddress">
        <div class="info-label">{{ 'ShippingAddress' | translate }}</div>
        <div class="info-value">
          <div>{{ this.OfferRequest.ShippingAddress.AddressLine }}</div>
          <div>{{ this.OfferRequest.ShippingAddress.City }}<span *ngIf="this.OfferRequest.ShippingAddress.ZipCode">, {{ this.OfferRequest.ShippingAddress.ZipCode }}</span></div>
          <div *ngIf="this.OfferRequest.ShippingAddress.State">{{ this.OfferRequest.ShippingAddress.State }}</div>
          <div>{{ this.OfferRequest.ShippingAddress.Country?.Name }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Payment Details -->
  <div class="section-card">
    <h2 class="section-title">{{ 'PaymentDetails' | translate }}</h2>

    <div class="info-grid">
      <div class="info-item">
        <div class="info-label">{{ 'PaymentTerms' | translate }}</div>
        <div class="info-value">{{ OfferRequest?.Cart?.PaymentTerm?.Name }}</div>
      </div>

      <div class="info-item" *ngIf="this.OfferRequest?.Cart?.PaymentType?.Name?.length > 0">
        <div class="info-label">{{ 'PaymentType' | translate }}</div>
        <div class="info-value">{{ this.OfferRequest?.Cart?.PaymentType?.Name }}</div>
      </div>
    </div>
  </div>

  <!-- Status & Next Steps -->
  <div class="status-cards">
    <div class="status-card">
      <div class="status-icon">
        <i class="material-icons">info</i>
      </div>
      <div class="status-content">
        <div class="status-label">{{ 'Status' | translate }}</div>
        <div class="status-text">{{ OfferRequest?.OfferRequestStatus?.Description }}</div>
      </div>
    </div>

    <div class="status-card status-card-accent">
      <div class="status-icon">
        <i class="material-icons">schedule</i>
      </div>
      <div class="status-content">
        <div class="status-label">{{ 'WhatsNext' | translate }}</div>
        <div class="status-text">{{ OfferRequest?.OfferRequestStatus?.NextStep }}</div>
      </div>
    </div>
  </div>

  <!-- CTA Button -->
  <div class="cta-container">
    <button class="apple-button" (click)="this.parent.RedirectToURLWithUrlChange('/B2B/search');">
      <span>{{ 'BackToStore' | translate }}</span>
      <i class="material-icons">arrow_forward</i>
    </button>
  </div>

</div>